import { Route } from "react-router-dom";
import Home from "./page.highorder";
import AuthorizedRoute from "../../components/routing/authorized-route";
import { Roles } from "../../components/routing/utils";

const ProtectedHome = () => (
  <AuthorizedRoute
    requiredRoles={[Roles.NURSE, Roles.NURSEADMIN]}
    component={Home}
  />
);

const homeRoute = (
  <Route path="/residents-overview" element={<ProtectedHome />} />
);

export default homeRoute;
